// extracted by mini-css-extract-plugin
export default {"success_modal":"SuccessModal_success_modal__zCBrS","close_btn":"SuccessModal_close_btn__pzqpT","success_msg":"SuccessModal_success_msg__znEW0"};